import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://wrgmicftdykgaygbnkqn.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndyZ21pY2Z0ZHlrZ2F5Z2Jua3FuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU2MDIzNTYsImV4cCI6MjA4MTE3ODM1Nn0.CpRdUWBAti0qGCLKIZCaydk4h4Nnifx6apBEwy0k4E8'

// Read auth token directly from localStorage (bypasses Supabase auth module)
function getAccessToken() {
  try {
    const data = JSON.parse(localStorage.getItem('sb-wrgmicftdykgaygbnkqn-auth-token') || 'null');
    return data?.access_token || null;
  } catch { return null; }
}

// Data-only Supabase client — bypasses the auth module's session lock.
//
// WHY: The main Supabase client's _initialize() can hang when INITIAL_SESSION
// doesn't fire (a known v2 issue). Since _initialize() holds the auth lock,
// ALL supabase.from() calls deadlock waiting for getSession().
//
// This client has persistSession:false so _initialize() completes immediately.
// Auth is injected via custom fetch reading the token from localStorage directly.
// Use this for ALL data queries (from/rpc). Use the main client only for auth ops.
export const supabaseData = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'x-client-info': 'workvan-data',
    },
    fetch: (url, options = {}) => {
      const token = getAccessToken();
      if (token) {
        const headers = new Headers(options.headers);
        headers.set('Authorization', `Bearer ${token}`);
        options = { ...options, headers };
      }
      return fetch(url, options);
    },
  },
})
